import { Body, Button, Col, H2, Row } from 'atomic'

import { Modal } from 'atomic/legacy/obj.modal'

import React from 'react'

import { AlreadyRegisterStyled } from './already-register-modal.component.style'

interface AlreadyRegisterProps {
  open: boolean
  onClose: () => void
  buttonText: string
  messageText: string
}

const getBrandLink = brand => {
  switch (brand) {
    case 'fleury':
      return 'https://medicos.fleury.com.br/'
    case 'weinmann':
      return 'https://medicos.weinmann.com.br/'
    case 'felippe-mattoso':
      return 'https://medicos.fmattoso.com.br/'
    default:
      return 'https://medicos.fleury.com.br/'
  }
}

export const AlreadyRegisterModal: React.FunctionComponent<AlreadyRegisterProps> = props => {
  return (
    <AlreadyRegisterStyled>
      <Modal small onClose={props.onClose} opened={props.open}>
        <Row mb>
          <Col xs={12} className="col-wrapper">
            <H2>Atenção</H2>
            <Body>{props.messageText}</Body>
            <Button
              external
              target="_blank"
              to={getBrandLink(process.env.GATSBY_COSMIC_BUCKET)}
              onClick={props.onClose}
            >
              {props.buttonText}
            </Button>
          </Col>
        </Row>
      </Modal>
    </AlreadyRegisterStyled>
  )
}
